// BookTickets/lib/money.ts

export function formatPrice(value: number): string {
  const price = value / 100
  const final = price % 1 === 0 ? price : price.toFixed(2)
  return `${final}€`
}

/**
 * GA expects a string. This matches your old implementation.
 */
export function numToPriceFormat(num: number): string {
  return (Math.ceil(num * 100) / 100).toString()
}
